export const columns = [{
    name: 'Status',
    key: 'status',
}, {
    name: '# of Properties',
    key: 'properties',
    class: 'Pipeline_column_numeric',
}, {
    name: 'Loan Amount',
    key: 'loanAmount',
    class: 'Pipeline_column_numeric',
    format: '$',
}, {
    name: 'Total Gross Fee',
    key: 'totalGrossFee',
    class: 'Pipeline_column_numeric',
    format: '$',
    withCents: true,
}, {
    name: 'Referral',
    key: 'referral',
    class: 'Pipeline_column_numeric',
    format: '$',
    withCents: true,
}, {
    name: 'Credits',
    key: 'credits',
    class: 'Pipeline_column_numeric',
    format: '$',
    withCents: true,
}, {
    name: 'Bank Bonus',
    key: 'bankBonus',
    class: 'Pipeline_column_numeric',
    format: '$',
    withCents: true,
}, {
    name: 'PEAK Fee',
    key: 'hscFee',
    class: 'Pipeline_column_numeric',
    format: '$',
    withCents: true,
}];